import { FEATURE } from '~/common/enums/feature.enum';
import SignUp from '~/components/shared/Auth/SignUp';
// todo: move to the common domain
import { serverFlags } from '~/domains/feature-flags/serverFlags';

export async function getServerSideProps() {
  const isReferAFriendEnabled = await serverFlags.getTreatment(
    'anonymous',
    FEATURE.ENABLE_REFER_A_FRIEND_V2
  );

  return {
    props: {
      isReferAFriendEnabled: isReferAFriendEnabled === 'on',
    },
  };
}

function SignUpPage() {
  return <SignUp />;
}

export default SignUpPage;

SignUpPage.isPublic = true;
SignUpPage.trackingName = 'Registration';
